import { useT } from '../../i18n';

// [Proposition: documents] Proposals-page tab: where documents can be attached
// and how they're traced. The register itself lives at the bottom of the
// milestones/tasks view.
export function DocumentsProposal() {
  const { t } = useT();
  return (
    <div>
      <div className="section-label mb-8">{t('docs.prop.whereTitle')}</div>
      <ul className="text-sm text-ink-2 mb-16" style={{ margin: 0, paddingLeft: 'var(--s16)', lineHeight: 1.8 }}>
        <li>{t('docs.prop.where.todo')}</li>
        <li>{t('docs.prop.where.task')}</li>
        <li>{t('docs.prop.where.milestone')}</li>
        <li>{t('docs.prop.where.project')}</li>
      </ul>
      <div className="section-label mb-8" style={{ marginTop: 'var(--s16)' }}>{t('docs.prop.traceTitle')}</div>
      <ul className="text-sm text-ink-2" style={{ margin: 0, paddingLeft: 'var(--s16)', lineHeight: 1.8 }}>
        <li>{t('docs.prop.trace.kinds')}</li>
        <li>{t('docs.prop.trace.who')}</li>
        <li>{t('docs.prop.trace.register')}</li>
        <li>{t('docs.prop.trace.attach')}</li>
        <li>{t('docs.prop.trace.history')}</li>
        <li>{t('docs.prop.trace.private')}</li>
        <li>{t('docs.prop.trace.next')}</li>
      </ul>
    </div>
  );
}
